<template>
  <div id="app" class='section'>

    <!-- modal -->
    <div class="modal" :class="{'is-active': modalStatus}">
      <div class="modal-background" />
      <div class="modal-content has-text-left">
        <p>Hi! This website tells the story of the Memonavirus, a fictional virus that started on Reddit. Reddit hosted <a href="https://www.reddit.com/r/dataisbeautiful/comments/fwmsqr/battle_dataviz_battle_for_the_month_of_april_2020/">a data visualization competition</a> for the Memonavirus and this was my entry. <a href="https://www.reddit.com/r/dataisbeautiful/comments/ge4n8r/battle_data_viz_battle_winners_of_april_2020/">It won.</a></p>
        <br>
        <a href="#" @click="modalStatus=false">Click here to continue</a>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="modalStatus = false"/>
    </div>

    <!-- content -->
    <div class='container'>
      
      <div class='columns is-centered'>
        
        <div class='column 
          is-6-widescreen 
          is-8-desktop 
          is-10-tablet'>

          <p class='title is-1 is-size-2-mobile'>MEMONAVIRUS</p>
          <p class='subtitle is-6'>an analysis by <a href="https://againwewander.com" class='my-link'>AgainWeWander</a></p>

          <hr>

          <div class='my-content-block'>
            <MyIcons />
            <PatientZero />
            <HowItWorks />  
            <MyWordTree :mobile="mobile" />
            <MyLineCharts />
            <InfectionCauses :mobile="mobile" />
            <InfectorsVsNon :mobile="mobile" />
            <EvilBots />
            <FastFinale />
          </div>

          <div class='my-content-block'>
            <Superlatives />
          </div>

          <div class='my-content-block'>
            <UserSearch/>
            <DataNotes/>
          </div>

        </div>

      </div>


    </div>
  </div>
</template>

<script>

import MyIcons from './components/MyIcons.vue'
import PatientZero from './components/PatientZero.vue'
import HowItWorks from './components/HowItWorks.vue'
import MyWordTree from './components/MyWordTree.vue'
import MyLineCharts from './components/MyLineCharts.vue'
import InfectionCauses from './components/InfectionCauses.vue'
import InfectorsVsNon from './components/InfectorsVsNon.vue'
import EvilBots from './components/EvilBots.vue'
import FastFinale from './components/FastFinale.vue'
import Superlatives from './components/Superlatives.vue'
import UserSearch from './components/UserSearch.vue'
import DataNotes from './components/DataNotes.vue'


export default {
  name: 'App',
  data() {
    return {
      window: {
          width: 0,
          height: 0
      },
      modalStatus: true
    }
  },
  computed: {
    mobile() {
      return this.window.width < 600;
    },
  },
  created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
  },
  destroyed() {
      window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
  },
  components: {
    MyIcons,
    PatientZero,
    HowItWorks,
    MyWordTree,
    MyLineCharts,
    InfectionCauses,
    InfectorsVsNon,
    EvilBots,
    FastFinale,
    Superlatives,
    UserSearch,
    DataNotes,
  }
}
</script>

<style lang="scss">
@import '~bulma';

#app {
  font-family: Cabin, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
}


.modal-content {
  padding: 2rem;
  background-color: white;

  a:hover {
    text-decoration: underline;
  }
}

p {
  line-height: 1.66rem;
}

.my-link {
  color:  $info;
  text-decoration: underline solid $info;
}
.my-link:hover {
  text-decoration: underline solid black;
}

.section {
  padding-top: 2rem;
}

div .myTile {
  @include tablet {
    padding: 2rem;
  }
  padding: 2rem 1rem 2rem 1rem;

  background-color: #F0F0F0;
  margin-top: 4rem;
  margin-bottom: 4rem;
  color: #333;

}

.my-content-block {
  @include tablet {
    padding: 3rem 1.5rem 3rem 1.5rem
  }

  padding: 3rem 0rem;
}

.title, .subtitle {
  font-family: Permanent Marker;
}

.userName {
  color:  $danger;
  font-family: Permanent Marker;
  backgroundColor: white;
  font-size: 1.33rem;
  padding: 0 .25rem 0 .25rem;
}

.myNumber {
  color:  $info;
  font-family: Permanent Marker;
  backgroundColor: white;
  font-size: 1.33rem;
  padding: 0 .25rem 0 .25rem;
}

.chartTitle {
  font-weight: bold;
  padding-bottom: .5rem;
}

.legendList {
  list-style-type: disc;
  list-style-position: inside;
}

.rule {
  padding: 0;
  margin-top: 0;
  margin-bottom: .5rem;
  color: black;
  background-color: black;
}


</style>
